"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const newsFeedSlice_1 = require("../../redux/slices/newsFeedSlice");
const feedItem_1 = __importDefault(require("./components/feedItem/feedItem"));
require("./app.scss");
const feedView_1 = __importDefault(require("./components/modals/feedView"));
const deleteComment_1 = __importDefault(require("./components/modals/deleteComment"));
const infiniteScroll_1 = __importDefault(require("../../shared/components/infiniteScroll/infiniteScroll"));
class App extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false
        };
        this.handleModalChange = () => {
            this.props.toggleNewsFeedModal();
        };
        this.handleDeleteModalChange = () => {
            this.props.toggleDeleteCommentModal();
        };
        this.loadMoreContent = async () => {
            const { feed } = this.props;
            this.setState({ loading: true });
            await this.props.loadMoreNews({ offset: feed.length });
            this.setState({ loading: false });
        };
    }
    componentDidMount() {
        this.props.getNewsFeed();
    }
    componentWillUnmount() {
        this.props.resetState();
    }
    render() {
        const { feed, allLoaded } = this.props;
        const { loading } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("h3", { className: 'page-title' }, "News Feed"),
            react_1.default.createElement("div", { className: 'news-feed-page' }, (feed === null || feed === void 0 ? void 0 : feed.length) ? react_1.default.createElement(infiniteScroll_1.default, { hasMore: !allLoaded, isLoading: loading, onLoadMore: this.loadMoreContent }, feed.map((val) => (react_1.default.createElement(feedItem_1.default, { news: val, key: val.id }))))
                :
                    react_1.default.createElement("div", { className: 'no-news' },
                        react_1.default.createElement("div", { className: 'icon' }),
                        react_1.default.createElement("div", { className: 'text' }, "No results to show."))),
            react_1.default.createElement(feedView_1.default, { toggleModal: this.handleModalChange }),
            react_1.default.createElement(deleteComment_1.default, { toggleModal: this.handleDeleteModalChange })));
    }
}
const mapStateToProps = (state) => {
    const { newsFeed } = state;
    return {
        feed: newsFeed.feed,
        allLoaded: newsFeed.allLoaded
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getNewsFeed: () => dispatch(newsFeedSlice_1.getFeed()),
        toggleNewsFeedModal: () => dispatch(newsFeedSlice_1.toggleNewsFeedModal()),
        toggleDeleteCommentModal: () => dispatch(newsFeedSlice_1.toggleDeleteCommentModal()),
        loadMoreNews: (data) => dispatch(newsFeedSlice_1.loadMore(data)),
        resetState: () => dispatch(newsFeedSlice_1.resetState())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
